import React, { useEffect, useRef, useState, useCallback } from 'react';
import {
   Box,
   Paper,
   Menu,
   MenuItem,
   Typography,
   IconButton,
   Divider,
   Modal,
   Input,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import {
   faPlus,
   faQuestionCircle,
   faList,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import QuestionSectionComponent from './component/Question/QuestionSectionComponent';
import QuestionAnswerComponent from './component/Question/QuestionAnswerComponent';
import Delete from './component/Delete';

const useStyles = makeStyles((theme) => ({
   containerPaper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
      marginBottom: '24px',
   },
   addQuetion: {
      width: '40px',
      height: '40px',
      backgroundColor: '#FFD657',
      borderRadius: '0 0 5px 5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover': {
         backgroundColor: '#FFC107',
      },
   },
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
}));

const QuestionSurvey = ({
   value,
   onValueChange,
   onActionTriggerAdd,
   onDeleteSection,
}) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(true);

   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);

   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });

   const sections = {
      sectionId: 0,
      // surveyGroupId: value[0].surveyGroupId,
      surveyGroupId: value?.[0]?.surveyGroupId || null,
      secNameTh: 'Section Name',
      secNameEn: 'Section Name',
      secDescTh: '',
      secDescEn: '',
      nextStepType: 1,
      nextStepDesc: 'Continue to next section',
      nextSectionId: 0,
      isBreakPage: true,
      question: [
         {
            questionId: 0,
            quesNameTh: 'Question Name',
            quesNameEn: 'Question Name',
            quesDescTh: '',
            quesDescEn: '',
            inputType: 1,
            inputTypeDesc: 'Text',
            choiceMode: 1,
            choiceModeDesc: 'Single Choice',
            quesImageURL: '',
            isRequired: false,
            nextStepType: 2,
            nextStepDesc: 'Continue to next question',
            nextSectionId: 0,
            nextQuestionId: 0,
            answerMin: 0,
            answerMax: 0,
            option: [
               {
                  optionId: 0,
                  optionTh: 'choice',
                  optionEn: '',
                  optionImageUrl: '',
                  nextStepType: 2,
                  nextStepDesc: 'Continue to Next Question',
                  NextSectionId: 0,
                  NextQuestionId: 0,
               },
            ],
         },
      ],
   };

   const question = {
      questionId: 0,
      quesNameTh: 'Question Name',
      quesNameEn: 'Question Name',
      quesDescTh: '',
      quesDescEn: '',
      inputType: 1,
      inputTypeDesc: 'Text',
      choiceMode: 1,
      choiceModeDesc: 'Single Choice',
      quesImageURL: '',
      isRequired: false,
      nextStepType: 2,
      nextStepDesc: 'Continue to next question',
      nextSectionId: 0,
      nextQuestionId: 0,
      answerMin: 0,
      answerMax: 0,
      option: [
         {
            optionId: 0,
            optionTh: 'choice',
            optionEn: 'choice',
            optionImageUrl: '',
            nextStepType: 2,
            nextStepDesc: 'Continue to Next Question',
            NextSectionId: 0,
            NextQuestionId: 0,
         },
      ],
   };

   const [myMenu, setMyMenu] = useState(null);
   const [selectedOption, setSelectedOption] = useState('');

   // ฟังก์ชันเปิดเมนู;
   const handleMyMenuClick = (event, sectionId) => {
      // setCurrentSectionId(sectionId);
      setMyMenu(event.currentTarget);
   };

   // ฟังก์ชันปิดเมนู;
   const handleMyMenuClose = () => {
      setMyMenu(null);
   };

   // ฟังก์ชันเลือกเมนูและปิด
   const handleMenuItemSelect = (type, section, sectionIndex) => {
      let updatedValue;

      if (type === 'section') {
         updatedValue = [...value, sections];
      } else if (type === 'question') {
         updatedValue = value.map((section, index) => ({
            ...section,
            question: [...section.question, question],
         }));
      }

      onValueChange(updatedValue);

      if (onActionTriggerAdd) {
         onActionTriggerAdd(updatedValue);
      }

      handleMyMenuClose();
   };

   const handleDuplicateSection = (data) => {
      // คัดลอก Section และอัปเดตค่าใหม่
      const duplicatedSection = {
         ...data,
         sectionId: 0, // ตั้งค่าเป็น 0 เพื่อรอระบบสร้างใหม่
         secNameTh: `${data.secNameTh} (คัดลอก)`, // เพิ่มข้อความคัดลอก
         secNameEn: `${data.secNameEn} (copy)`,
         question: data.question.map((q) => ({
            ...q,
            questionId: 0, // ตั้งค่าใหม่
            quesNameTh: `${q.quesNameTh}`,
            quesNameEn: `${q.quesNameEn}`,
            option: q.option.map((opt) => ({
               ...opt,
               optionId: 0, // ตั้งค่าใหม่
            })),
         })),
      };

      // คำนวณตำแหน่งของ section ที่ต้องการคัดลอก
      const sectionIndex = value.findIndex(
         (section) => section.sectionId === data.sectionId,
      );

      // อัปเดตรายการ Sections โดยเพิ่ม section ใหม่ในตำแหน่งถัดไป
      const updatedValue = [
         ...value.slice(0, sectionIndex + 1), // ส่วนก่อน section ที่เลือก
         duplicatedSection, // เพิ่ม section ที่คัดลอก
         ...value.slice(sectionIndex + 1), // ส่วนหลัง section ที่เลือก
      ];

      // ส่งค่าใหม่กลับไปยัง state
      onValueChange(updatedValue);

      if (onActionTriggerAdd) {
         onActionTriggerAdd(updatedValue);
      }
   };

   const handleCopyQuestion = (section, question, qIndex) => {
      // คัดลอกคำถามโดยใช้ spread operator และแก้ไขค่า
      const copiedQuestion = {
         ...question,
         questionId: 0, // กำหนด questionId ใหม่
         quesNameTh: `${question.quesNameTh} (คัดลอก)`, // แสดงว่าเป็นการคัดลอก
         quesNameEn: `${question.quesNameEn} (copy)`,
         option: question.option.map((opt) => ({
            ...opt,
            optionId: 0, // สร้าง optionId ใหม่
         })),
      };

      // อัปเดต sections โดยเพิ่มคำถามใหม่
      const updatedValue = value.map((item) =>
         item.sectionId === section.sectionId
            ? {
                 ...item,
                 question: [
                    ...item.question.slice(0, qIndex + 1), // คำถามก่อนตำแหน่งปัจจุบัน
                    copiedQuestion, // เพิ่มคำถามที่คัดลอก
                    ...item.question.slice(qIndex + 1), // คำถามหลังตำแหน่งปัจจุบัน
                 ],
              }
            : item,
      );

      // ส่งค่าใหม่กลับไปยัง state
      onValueChange(updatedValue);

      if (onActionTriggerAdd) {
         onActionTriggerAdd(updatedValue);
      }
   };

   // ฟังก์ชั่นสำหรับลบคำถาม
   const handleRemoveQuestion = (section, question, qIndex) => {
      setModalStyle(section, question, qIndex);
   };

   const deleteQuestion = (section, question, qIndex) => {
      // อัปเดต sections โดยกำหนดค่า isDelete: true ให้กับคำถามที่ถูกลบ
      const updatedValue = value.map((item) =>
         item.sectionId === section.sectionId
            ? {
                 ...item,
                 question: item.question.map((ques, i) =>
                    i === qIndex
                       ? { ...ques, isDelete: true } // เพิ่ม isDelete: true
                       : ques,
                 ),
              }
            : item,
      );

      // ส่งค่าที่อัปเดตกลับไปยัง state
      onValueChange(updatedValue);

      // ตรวจสอบและเรียกใช้งานฟังก์ชันเพิ่มเติมหากมี
      if (onActionTriggerAdd) {
         onActionTriggerAdd(updatedValue);
      }
   };

   const setModalStyle = (section, question, qIndex) => {
      setMyModal(
         <Delete
            onClickClose={() => setShowModal(false)}
            data={question}
            type={'question'}
            onSuccess={(type) => {
               if (type == 'question') {
                  deleteQuestion(section, question, qIndex);
               } else if (type == 'section') {
                  // deleteQuestion(section, qIndex);
               }
               setShowModal(false);
            }}
         />,
      );

      setShowModal(!showModal);
   };

   if (isError.error)
      return (
         <ErrorPopup
            // onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );

   const totalSections = value ? value.length : 0;

   return (
      <div className={classes.containerPaper}>
         {Array.isArray(value) &&
            value.slice(0, value.length).map((section, sectionIndex) => (
               <Box
                  // key={section.sectionId || sectionIndex} // ใช้ index เป็น fallback ถ้าไม่มี sectionId
                  width={'100%'}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  marginBottom={
                     sectionIndex < value.slice(0, value.length).length - 1
                        ? '25px'
                        : ''
                  }
               >
                  <Modal className={classes.modal} open={showModal}>
                     <React.Fragment>{myModal}</React.Fragment>
                  </Modal>

                  <QuestionSectionComponent
                     value={section}
                     onValueChange={(updatedItem) =>
                        onValueChange((prev) => {
                           const newArray = [...prev];
                           newArray[sectionIndex] = updatedItem;
                           return newArray;
                        })
                     }
                     onDeleteSection={onDeleteSection}
                     sectionNumber={sectionIndex + 1} // ลำดับ section
                     totalSections={totalSections} //จำนวน section ทั้งหมด
                     onDuplicateSection={handleDuplicateSection}
                  />

                  {section.question
                     .slice(0, section.question.length)
                     .map((question, qIndex) => (
                        <Box
                           width={'100%'}
                           marginBottom={
                              qIndex < section.question.length - 1 ? '6px' : ''
                           }
                        >
                           {!question.isDelete && (
                              <QuestionAnswerComponent
                                 totalQuestions={section.question.length} //จำนวน question แต่ละ section
                                 value={question}
                                 onValueChange={(updatedQuestion) => {
                                    onValueChange((prev) => {
                                       const newSections = [...prev];
                                       const updatedQuestions = [
                                          ...newSections[sectionIndex].question,
                                       ];
                                       updatedQuestions[qIndex] =
                                          updatedQuestion;
                                       newSections[sectionIndex].question =
                                          updatedQuestions;
                                       return newSections;
                                    });
                                 }}
                                 onRemoveQuestion={() =>
                                    handleRemoveQuestion(
                                       section,
                                       question,
                                       qIndex,
                                    )
                                 }
                                 onCopyQuestion={() =>
                                    handleCopyQuestion(
                                       section,
                                       question,
                                       qIndex,
                                    )
                                 }
                              />
                           )}
                        </Box>
                     ))}

                  <IconButton
                     aria-label='เพิ่มเติม'
                     className={classes.addQuetion}
                     onClick={(e) => handleMyMenuClick(e, section.sectionId)}
                  >
                     <FontAwesomeIcon
                        color='#000000'
                        icon={faPlus}
                        style={{ fontSize: '18px' }}
                     />
                  </IconButton>

                  <Menu
                     id='simple-menu'
                     anchorEl={myMenu}
                     keepMounted
                     open={Boolean(myMenu)}
                     onClose={handleMyMenuClose}
                     anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                     }}
                     transformOrigin={{
                        vertical: 'top',
                        horizontal: 'bottom',
                     }}
                  >
                     {[
                        {
                           value: 'question',
                           label: 'Add Question',
                           icon: faQuestionCircle,
                        },
                        {
                           value: 'section',
                           label: 'Add Section',
                           icon: faList,
                        },
                     ].map((item) => (
                        <MenuItem
                           key={item.value}
                           selected={selectedOption === item.value}
                           onClick={() =>
                              handleMenuItemSelect(
                                 item.value,
                                 section,
                                 sectionIndex,
                              )
                           }
                        >
                           <Box
                              display='flex'
                              alignItems='center'
                              gridGap={'10px'}
                           >
                              <FontAwesomeIcon
                                 icon={item.icon}
                                 style={{ fontSize: '18px' }}
                              />
                              <Typography style={{ fontSize: '20px' }}>
                                 {item.label}
                              </Typography>
                           </Box>
                        </MenuItem>
                     ))}
                  </Menu>
               </Box>
            ))}
      </div>
   );
};

export default QuestionSurvey;
